module.exports = __webpack_public_path__ + "media/assets/faria_products/IDATCONCISE-f98e8d17ba245a3188caa91edcdbe0ef5f72747820a7569ad9e2437e0316c803.png";